/**
 * Coaching Service
 * API calls for coaching notes and review queue
 */

import { createApiClient } from '@shared/auth';
import apiConfig from '../config/apiConfig';
import { extractList, extractErrorMessage } from '../utils/responseHelpers';

const baseURL = apiConfig.getQAServiceUrl();

const client = createApiClient(baseURL);

/**
 * Get review queue (low-scoring interactions)
 */
export const getReviewQueue = async (params) => {
  try {
    const response = await client.get('/api/v1/coaching/review-queue', { params });
    return {
      success: true,
      data: {
        scores: extractList(response.data, 'scores'),
        total: response.data?.total ?? 0,
      },
    };
  } catch (error) {
    return { success: false, error: extractErrorMessage(error, 'Failed to fetch review queue.') };
  }
};

/**
 * Get coaching notes
 */
export const getCoachingNotes = async (params) => {
  try {
    const response = await client.get('/api/v1/coaching-notes', { params });
    return {
      success: true,
      data: {
        notes: extractList(response.data, 'notes'),
        total: response.data?.total ?? 0,
      },
    };
  } catch (error) {
    return { success: false, error: extractErrorMessage(error, 'Failed to fetch coaching notes.') };
  }
};

/**
 * Create a coaching note
 */
export const createCoachingNote = async (data) => {
  try {
    const response = await client.post('/api/v1/coaching-notes', data);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: extractErrorMessage(error, 'Failed to create coaching note.') };
  }
};

/**
 * Update a coaching note
 */
export const updateCoachingNote = async (noteId, data) => {
  try {
    const response = await client.put(`/api/v1/coaching-notes/${noteId}`, data);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: extractErrorMessage(error, 'Failed to update coaching note.') };
  }
};

/**
 * Delete a coaching note
 */
export const deleteCoachingNote = async (noteId) => {
  try {
    await client.delete(`/api/v1/coaching-notes/${noteId}`);
    return { success: true };
  } catch (error) {
    return { success: false, error: extractErrorMessage(error, 'Failed to delete coaching note.') };
  }
};

const coachingServiceDefault = {
  getReviewQueue,
  getCoachingNotes,
  createCoachingNote,
  updateCoachingNote,
  deleteCoachingNote,
};

export default coachingServiceDefault;
